// FORMAT: {module}_{kind}_{optional}
export const EMAIL_TRIGGER_POINTS = {
    INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change',
    INITIAL_PROPOSAL_CLIENT_RESPONSE: 'Initial Proposal Client Response',
    INITIAL_PROPOSAL_SUBMIT_LOAN_APPROVAL: 'Initial Proposal Submit Loan Approval',
    INITIAL_PROPOSAL_RESPONSE_LOAN_APPROVAL: 'Initial Proposal Response Loan Approval',
    CASE_APPROVE: 'Case Approve',
    CASE_REJECT: 'Case Reject',
    CASE_CREATED: 'Case Created',
    LOAN_ADVISORY: 'Send To Advisory',
    ASSIGN_ADVISOR: 'Assign Advisor',
    CASE_PENDING_APPROVAL: 'Case Pending Approval',
    CREATE_CASE_APPROVAL: 'Create Case Approval',
		CASE_SUBMIT_TO_BANKER: 'Submit Case To Banker (Assign To Banker)',
		CASE_ACCEPTED_BY_BANKER: 'Banker Accepted Case',
};

export const NOTIFICATION_TRIGGER_POINTS = {
    LEAD_STATUS_CHANGE: 'Lead Status Change',
    CASE_STATUS_CHANGE: 'Case Status Change',
    CUSTOMER_STATUS_CHANGE: 'Customer Status Change',
    CHAT_MESSAGE: 'Chat Message',
    INITIAL_PROPOSAL_STATUS_CHANGE: 'Initial Proposal Status Change',
    INITIAL_PROPOSAL_CLIENT_RESPONSE: 'Initial Proposal Client Response',
    INITIAL_PROPOSAL_SUBMIT_LOAN_APPROVAL: 'Initial Proposal Submit Loan Approval',
    INITIAL_PROPOSAL_RESPONSE_LOAN_APPROVAL: 'Initial Proposal Response Loan Approval',
};

export const defaultEmailTemplates = {
	CASE_SUBMIT_TO_BANKER:{
		subject:'New Customer Received',
	content:'<h2>{template_title}</h2><p><strong>TAT:</strong> {tat_label}</p><p><strong>Customer Name:</strong> {customer_name}</p><p><strong>ID:</strong> <a href="{link_to_banker_login}">{customer_id}</a></p><p><strong>Sales Advisor Name:</strong> {ssa_name}</p><h5>Product:{product_name}</h5>{product_detail}<h5>Document</h5>{list_document}<p>Sales and Hub manager, Operation Related party</p>'
	},
	CASE_ACCEPTED_BY_BANKER:{
		subject:'Banker Accepted Case',
		content:'<h2>{template_title}</h2><p><strong>TAT:</strong> {tat_label}</p><p><strong>Customer Name:</strong> {customer_name}</p><p><strong>ID:</strong> <a href="{link_to_customer}">{customer_id}</a></p><p><strong>Channel:</strong> {channel}</p><p><strong>Sales Executive Name:</strong> {se_name}</p><h3>Product</h3>{list_product}<p>{status}</p><p>Sales and Hub manager, Operation Related party</p>'
	}
}

export const defaultSmsTemplates = {
	// EXAMPLE_SMS:{
	// 	content:'..short content..'
	// }
}
export const defaultNotifTemplates = {
	// EXAMPLE_NOTIF:{
	// 	content:'..short content..'
	// }
}